import * as constants from './constants';
import { router } from './router';

export const ServisniPakety = {
	name: constants.NAME,
	constants,
	router,
};
